import CheckLightResume from './ChecklightResume';
import Card from '../../../components/card/Card';
import Button from '../../../components/button/Button';
import { riskData } from '../../../types/interfaces';
import { APPLICATION_STATUS, RISK_CODES } from '../../../utils/Constants';
import { useState } from 'react';
import P from '../../../components/texts/p/P';
import TextArea from '../../../components/textarea/TextArea';
import Modal from '../../../components/modal/modal';
import { updateApplication } from '../../../services/ApplicationService';
import { Toast, useToast } from '../../../components/toast/toast';
import { useNavigate } from 'react-router-dom';
import Spinner from '../../../components/Spinner/spinner';
import { routes } from '../../../routes/routePaths';

interface CheckLightProps {
  handleNextStep: () => void;
  riskData: riskData | undefined;
  isLoading: boolean;
  handleRiskData: Function;
  handleUpdateDebts?: Function;
  handleRiskDataAndDebts?: Function;
  cuit: string | undefined;
  applicationId: string | undefined;
}

const CheckLight: React.FC<CheckLightProps> = ({
  handleNextStep,
  riskData,
  isLoading,
  handleRiskData,
  handleUpdateDebts,
  handleRiskDataAndDebts,
  cuit,
  applicationId,
}) => {
  const [isRejectApplication, setIsRejectApplication] =
    useState<boolean>(false);
  const [isSendingApplication, setIsSendingApplication] =
    useState<boolean>(false);
  const [modalText, setModalText] = useState<string>('');
  const navigate = useNavigate();

  const renderRejectModal = () => {
    return (
      <Card>
        <P type='1' variant='neutral' withMargin={false}>
          Declinar una solicitud eliminará la documentación.
        </P>
        <P type='1' variant='danger' withMargin={false}>
          Esta acción no se puede deshacer
        </P>
        <P type='1' variant='neutral' withMargin={false}>
          También podés solicitar cambios. Detallalos abajo, y la solicitud
          volverá al productor con ese pedido.
        </P>
        <Card margin={{ top: '3' }}>
          <TextArea
            placeHolder='Escribí los cambios que solicitás, o el motivo de la denegación.'
            maxLengthHelpText={false}
            onChange={(e) => setModalText(e.target.value)}
          ></TextArea>
        </Card>
      </Card>
    );
  };

  const handleApplication = (status: string) => {
    setIsSendingApplication(true);
    updateApplication(
      cuit || '',
      { status_code: status, comment: modalText },
      applicationId || ''
    ).then((response) => {
      const mapStatus = new Map();
      mapStatus.set(
        APPLICATION_STATUS.approved.label,
        'Aceptaste la documentación. El productor será notificado.'
      );
      mapStatus.set(
        APPLICATION_STATUS.rejected.label,
        'Declinaste la solicitud. El productor será notificado.'
      );
      mapStatus.set(
        APPLICATION_STATUS.pending.label,
        'Solicitaste cambios en la solicitud. El productor será notificado.'
      );

      if (response.status === 200) {
        useToast.success({
          title: mapStatus.get(status),
          id: 'application-toast',
          description: '',
          closeButton: false,
          autoClose: 5000,
        });
        setTimeout(() => {
          navigate(routes.dashboard);
        }, 1000);
      }
      setIsSendingApplication(false);
    });
  };
  return (
    <Card>
      <Toast id='application-toast' />
      <Modal
        isOpen={isRejectApplication}
        onClose={() => setIsRejectApplication(false)}
        title={'Declinar o solicitar cambios'}
        primaryText='Solicitar cambios'
        primaryVariant='primary'
        secondaryText='Declinar solicitud'
        secondaryVariant='secondary'
        onSecondaryAction={() => {
          setIsRejectApplication(false);
          handleApplication(APPLICATION_STATUS.rejected.label);
        }}
        onPrimaryAction={() => {
          setIsRejectApplication(false);
          handleApplication(APPLICATION_STATUS.pending.label);
        }}
        children={renderRejectModal()}
      />
      <Card spacing={{ left: '6' }}>
        <CheckLightResume
          data={riskData}
          showBalanceInfo={false}
          isLoading={isLoading}
          handleRiskData={handleRiskData}
          handleUpdateDebts={handleUpdateDebts}
          handleRiskDataAndDebts={handleRiskDataAndDebts}
          riskCodes={[RISK_CODES.nosis, RISK_CODES.casfog, RISK_CODES.bcra]}
          debts={riskData?.debts || []}
          hideInfo={false}
        />
        <Card
          display='flex'
          margin={{ top: '4' }}
          justifyContent='space-between'
        >
          <Card width='280px'>
            <Button
              id='checkRisk-button-reject'
              size='lg'
              variant='secondary'
              onClick={() => setIsRejectApplication(true)}
              fullWidth
              disabled={isSendingApplication || isLoading}
            >
              {isSendingApplication ? (
                <Spinner size='sm' variant='primary' />
              ) : (
                'Declinar o solicitar cambios'
              )}
            </Button>
          </Card>
          <Card width='210px'>
            <Button
              id='client-button-save'
              size='lg'
              variant='primary'
              fullWidth
              onClick={handleNextStep}
              disabled={isSendingApplication || isLoading}
            >
              {isSendingApplication ? (
                <Spinner size='sm' variant='primary' />
              ) : (
                'Continuar'
              )}
            </Button>
          </Card>
        </Card>
      </Card>
    </Card>
  );
};

export default CheckLight;
